// extracted by mini-css-extract-plugin
export var container = "_r1-0";
export var table = "_r1-2";
export var tableWrapper = "_r1-1";